var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.75C4.96165 0.75 3.94662 1.05791 3.08326 1.63478C2.2199 2.21166 1.54699 3.0316 1.14963 3.99091C0.752275 4.95022 0.648307 6.00582 0.85088 7.02422C1.05345 8.04262 1.55347 8.97808 2.28769 9.71231C3.02192 10.4465 3.95738 10.9466 4.97578 11.1491C5.99418 11.3517 7.04978 11.2477 8.00909 10.8504C8.9684 10.453 9.78834 9.7801 10.3652 8.91674C10.9421 8.05339 11.25 7.03835 11.25 6C11.25 4.60761 10.6969 3.27226 9.71231 2.28769C8.72775 1.30312 7.39239 0.75 6 0.75ZM6 3C6.11125 3 6.22001 3.03299 6.31251 3.0948C6.40501 3.15661 6.47711 3.24446 6.51968 3.34724C6.56226 3.45002 6.5734 3.56312 6.55169 3.67224C6.52999 3.78135 6.47642 3.88158 6.39775 3.96025C6.31908 4.03891 6.21885 4.09249 6.10974 4.11419C6.00063 4.1359 5.88753 4.12476 5.78474 4.08218C5.68196 4.03961 5.59411 3.96751 5.5323 3.87501C5.47049 3.78251 5.4375 3.67375 5.4375 3.5625C5.4375 3.41332 5.49677 3.27024 5.60225 3.16475C5.70774 3.05926 5.85082 3 6 3ZM7.5 9.04688H4.5V8.20312H5.57813V6.04688H4.875V5.20312H6.42188V8.20312H7.5V9.04688Z",
    fill: "#5A6574"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationFilled);
export default __webpack_public_path__ + "static/media/information--filled.a7da960b22bd02c651bd483c5bb2471e.svg";
export { ForwardRef as ReactComponent };